import React from 'react';
import { connect } from 'react-redux';
import { AppState } from '@Redux/store';
import { ContestMakePresenter } from '@Selectors/tournament/myContest/make/ContestMakePresenter';
import { Dispatch } from '@Redux/type';
import { FormattedMessage } from 'react-intl';
import myContestSlice from '@Redux/reducers/tournament/myContest.slice';
import { MyContestStateAction } from '@Stores/tournament/MyContestState';
import { defaultMessages } from '@I18n/default';

const ContestMake: React.FC<ContestMakeProps> = ({ datas, requestAddTeam, requestAddParticipant }) => {
  return <div className="builder-edit-app row justify-content-center">
    {datas.isLoading && <div className="loader" />}
    {!datas.isLoading && <div className="col-12">
      <h1 className="event-name text-center">
        <strong><FormattedMessage {...defaultMessages.tournamentContestName} /></strong> {datas.name}
        <br /><small>({datas.start} - {datas.end})</small></h1>

      <div className="row justify-content-center">
        {datas.showAllArmies && <section className="col-12">
          <p>All players of this tournament can see army lists of all teams :</p>
          <input id="link-list" value="<%= tournament_exports_all_armies_html_url(@contest) %>" />
          <button className="btn" data-clipboard-target="#link-list"><i className="far fa-2x actions fa-copy"></i>
          </button>
        </section>}
        {datas.mustAddTeam &&
          <section className="col-12 col-md-6 text-center">
            <h2 className="text-center"><FormattedMessage {...defaultMessages.tournamentTeamFirst} /></h2>
            <button className="btn btn-age btn-lg" onClick={() => requestAddTeam()}><i
              className="fas fa-user-plus"></i> <FormattedMessage {...defaultMessages.tournamentTeamAdd} /></button>
          </section>}
        {datas.mustAddTeam &&
          <section className="col-12 col-md-6 text-center">
            <h2 className="text-center"><FormattedMessage{...defaultMessages.tournamentTeamFirst}  /></h2>
            <button className="btn btn-age btn-lg" onClick={() => requestAddTeam()}><i
              className="fas fa-user-plus"></i> <FormattedMessage {...defaultMessages.tournamentTeamAdd} /></button>
          </section>}
        {datas.mustAddParticipant &&
          <section className="col-12 col-md-6 text-center">
            <h2 className="text-center"><FormattedMessage {...defaultMessages.tournamentUserApplyFirst} /></h2>
            <button className="btn btn-age btn-lg" onClick={() => requestAddParticipant()}><i
              className="fas fa-user-plus"></i> <FormattedMessage {...defaultMessages.tournamentUserApplyAdd} /></button>
          </section>}
      </div>

    </div>}
  </div>;
};

const mapStateToProps = (state: AppState) => ({
  datas: ContestMakePresenter(state)
});

const mapDispatchToProps = (dispatch: Dispatch) => (
  {
    requestAddTeam: () => dispatch(myContestSlice.actions.setRequest(MyContestStateAction.REQUEST_ADD_TEAM)),
    requestAddParticipant: () => dispatch(myContestSlice.actions.setRequest(MyContestStateAction.REQUEST_ADD_PARTICIPANT))
  }
);

export default connect(mapStateToProps, mapDispatchToProps)(ContestMake);

type ContestMakeProps = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>
